export default "__VITE_ASSET__BfwJrHJv__"